module.exports = __webpack_public_path__ + "static/media/23.e91623c2.jpg";